import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import FinancialAnalyzer from "./components/FinancialAnalyzer";
import JsonLD from "@/components/base/JsonLD";
import { analizaSchema } from "@/components/base/PageSchemas";
import Breadcrumb from "@/components/base/Breadcrumb";

export default function AnalizaPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLD data={analizaSchema} />
      <Navbar />
      <div className="pt-16 md:pt-20">
        <div className="px-4 md:px-8 lg:px-12 mb-4">
          <Breadcrumb />
        </div>
        <main>
          <FinancialAnalyzer />
        </main>
      </div>
      <Footer />
    </div>
  );
}